import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { onChange, setError, setOptions, validateForm } from '../../utils';
import AsideRightMenu from '../Dashboard/AsideRightMenu';
import NumericFormat from 'react-number-format';
import Loader from '../Common/Loader';
import { Typeahead } from 'react-bootstrap-typeahead';
import { citySearch, courseSpecializationList, educationqualificationList, jobQuestionList, searchSkill } from '../../action/jobs';

class Onboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FIRST_NAME: { name: "FIRST_NAME", value: "", error: '', isRequired: true, },
            LAST_NAME: { name: "LAST_NAME", value: "", error: '', isRequired: true, },
            MOBILE_NUMBER: { name: "MOBILE_NUMBER", value: "", error: '', isRequired: true, },
            EMAIL: { name: "EMAIL", value: "", error: '', isRequired: true, },
            WORK_STATUS: { name: "WORK_STATUS", value: "", error: '', isRequired: true, },
            RESUME: { name: "RESUME", value: "", error: '', isRequired: true, },
            SALARY_IN_LAKH: { name: "SALARY_IN_LAKH", value: "", error: '', isRequired: true, },
            SALARY_IN_THOUSAND: { name: "SALARY_IN_THOUSAND", value: "", error: '', isRequired: true, },
            TOTAL_EXPERIENCE_YEAR: { name: "TOTAL_EXPERIENCE_YEAR", value: "", error: '', isRequired: false, },
            TOTAL_EXPERIENCE_MONTH: { name: "TOTAL_EXPERIENCE_MONTH", value: "", error: '', isRequired: false, },
            LOCATION: { name: "LOCATION", value: [], options: [], error: '', isRequired: true, },
            PREFERRED_LOCATION: { name: "PREFERRED_LOCATION", value: [], options: [], error: '', isRequired: true, },
            GENDER: { name: 'GENDER', value: '', options: props.GENDER_OPTIONS ? props.GENDER_OPTIONS : [], error: '', isRequired: true },
            DOB: { name: 'DOB', value: '', error: '', isRequired: true },
            NOTICE_PERIOD: { name: "NOTICE_PERIOD", value: "", error: '', isRequired: false, },
            EDUCATION: { name: "EDUCATION", value: "", error: '', isRequired: true, },
            COURSE: { name: "COURSE", value: "", options: [], error: '', isRequired: true, },
            SPECIALIZATION: { name: "SPECIALIZATION", value: "", options: [], error: '', isRequired: true, },
            INSTITUTE: { name: "INSTITUTE", value: "", error: '', isRequired: true, },
            COURSE_TYPE: { name: "COURSE_TYPE", value: "", options: [], error: '', isRequired: true, },
            PASSING_OUT_YEAR: { name: "PASSING_OUT_YEAR", value: "", error: '', isRequired: true, },
            GRADING_SYSTEM: { name: "GRADING_SYSTEM", value: "", error: '', isRequired: true, },
            MARKS: { name: "MARKS", value: "", error: '', isRequired: true, },
            SELECTED_SKILLS: [],
            KEYWORDS: {
                name: "KEYWORDS",
                value: [],
                options: [],
                error: "",
                isRequired: true,
            },


        }

    }
    onChange = (e) => {
        const { name, value } = e.target;
        if (name === 'EDUCATION') {

            onChange(this, name, value)
            educationqualificationList(value).then(res => {
                if (res.status) {
                    setOptions(this, 'COURSE', res.result)
                }
            })
        }
        else if (name === 'COURSE') {
            onChange(this, name, value)
            courseSpecializationList(value).then(res => {
                if (res.status) {
                    setOptions(this, 'SPECIALIZATION', res.result)
                }
            })
        }
        else {
            onChange(this, name, value)
        }
    }
    onFileUpload = (e) => {
        let files = e.target.files
        if (files && files.length) {
            if (files[0].size <= 5000000 && (files[0].type == "application/pdf" || files[0].type == "application/msword" || files[0].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                onChange(this, this.state.RESUME.name, files[0])
            }
            else {
                onChange(this, this.state.RESUME.name, null)
                swal({
                    icon: "error",
                    text: "File size must be less than 5 MB. File Type must be PDF, DOC, DOCX.",
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            }

        }
    }


    onKeywordPress = (value, TYPE) => {
        if (TYPE === "PREFERRED_LOCATION") {
            citySearch(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.PREFERRED_LOCATION.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        }
        else if (TYPE === "LOCATION") {
            citySearch(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.LOCATION.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        } else if (TYPE === "QUESTION") {
            jobQuestionList(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.QUESTION.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        } else if (TYPE === "SKILL") {
            searchSkill(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.KEYWORDS.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        }
    };


    skillsOnChange = (e) => {

        function getUniqueListBy(arr, key) {
            return [...new Map(arr.map((item) => [item[key], item])).values()];
        }
        let val = [];
        if (e.length > 0) {
            val = e[e.length - 1];
        }
        onChange(this, this.state.KEYWORDS.name, val);
        if (e[0]) {
            val = this.state.SELECTED_SKILLS.concat(val);
            val = val.map((item, index) => {
                if (item.SKILL) {
                    return { SKILL: item.SKILL };
                } else if (item.label) {
                    return { SKILL: item.label };
                }
            });
            val = getUniqueListBy(val, "SKILL");
            this.setState({ SELECTED_SKILLS: val });
        }
    };
    deleteSKills = (SKILL) => {
        const { SELECTED_SKILLS } = this.state;
        let arr = SELECTED_SKILLS.filter((item) => {
            if (item.SKILL != SKILL) {
                return item;
            }
        });
        this.setState({ SELECTED_SKILLS: arr });
        onChange(this, this.state.KEYWORDS.name, arr)
    };


    onSubmit = (e) => {
        e.preventDefault();

        const { FIRST_NAME, LAST_NAME, MOBILE_NUMBER, EMAIL, WORK_STATUS, RESUME, SALARY_IN_LAKH, SALARY_IN_THOUSAND, LOCATION,
            GENDER, PREFERRED_LOCATION, TOTAL_EXPERIENCE_YEAR, TOTAL_EXPERIENCE_MONTH, NOTICE_PERIOD, SELECTED_SKILLS,
            DOB, EDUCATION, COURSE, SPECIALIZATION, INSTITUTE, COURSE_TYPE,
            PASSING_OUT_YEAR, GRADING_SYSTEM, MARKS } = this.state;
        if (validateForm(this)) {
            debugger
            if (this.state.MOBILE_NUMBER.value.length == 10 || this.state.MOBILE_NUMBER.value.length == 13) {
                const formData = new FormData();
                formData.append('FIRST_NAME', FIRST_NAME.value);
                formData.append('LAST_NAME', LAST_NAME.value);
                formData.append('MOBILE_NUMBER', MOBILE_NUMBER.value);
                formData.append('EMAIL', EMAIL.value);
                formData.append('WORK_STATUS', WORK_STATUS.value);
                formData.append('SALARY_IN_LAKH', SALARY_IN_LAKH.value);
                formData.append('SALARY_IN_THOUSAND', SALARY_IN_THOUSAND.value);
                formData.append('LOCATION', LOCATION.value[0].CITY);
                formData.append('TOTAL_EXPERIENCE_YEAR', TOTAL_EXPERIENCE_YEAR.value);
                formData.append('TOTAL_EXPERIENCE_MONTH', TOTAL_EXPERIENCE_MONTH.value);
                formData.append('NOTICE_PERIOD', NOTICE_PERIOD.value);
                formData.append('PREFERRED_LOCATION', PREFERRED_LOCATION.value[0].CITY_ID)
                formData.append('GENDER_ID', GENDER.value)
                formData.append('DOB', DOB.value)
                formData.append('SKILLS', SELECTED_SKILLS.map(item => {
                    return `'` + item.SKILL + `'`
                }).join(','));
                formData.append('resume', RESUME.value)
                formData.append('QUALIFICATION_ID', EDUCATION.value)
                formData.append('EDUCATION_QUALIFICATION_ID',COURSE.value)
                formData.append('SPECIALIZATION_ID',SPECIALIZATION.value)
                formData.append('UNIVERSITY_INSTITUTE',INSTITUTE.value)
                formData.append('COURSE_TYPE_ID',COURSE_TYPE.value)
                formData.append('PASSING_OUT_YEAR',PASSING_OUT_YEAR.value)
                formData.append('GRADING_SYSTEM_ID',GRADING_SYSTEM.value)
                formData.append('MARKS',MARKS.value)

                this.props.onSubmit(formData)
            }
            else {
                setError(this, MOBILE_NUMBER.name, 'invalid Phone Number')
            }
        }



    }
    locationOnChange = (e) => {
        onChange(this, this.state.PREFERRED_LOCATION.name, e);
    };

    deletePrefferedLocation = (input) => {
        const { PREFERRED_LOCATION } = this.state;
        let arr = PREFERRED_LOCATION.value.filter((item) => {
            if (item.CITY != input) {
                return item;
            }
        });

        onChange(this, this.state.PREFERRED_LOCATION.name, arr);
    };


    deleteLocation = (input) => {
        const { LOCATION } = this.state;
        let arr = LOCATION.value.filter((item) => {
            if (item.CITY != input) {
                return item;
            }
        });

        onChange(this, this.state.LOCATION.name, arr);
    };

    render() {
        const { FIRST_NAME, LAST_NAME, MOBILE_NUMBER, EMAIL, WORK_STATUS, RESUME, SALARY_IN_LAKH,
            SALARY_IN_THOUSAND, LOCATION, PREFERRED_LOCATION, KEYWORDS, TOTAL_EXPERIENCE_YEAR, TOTAL_EXPERIENCE_MONTH,
            NOTICE_PERIOD, SELECTED_SKILLS, DOB, GENDER, EDUCATION, COURSE, SPECIALIZATION, INSTITUTE, COURSE_TYPE,
            PASSING_OUT_YEAR, GRADING_SYSTEM, MARKS } = this.state;
        const { showLoader, EDUCATION_OPTIONS, COURSE_TYPE_OPTIONS, GRADING_SYSTEM_OPTIONS, GENDER_OPTIONS } = this.props;


        return (
            <React.Fragment>
                <section className="pricing-area padding-top-100px padding-bottom-80px">
                    {showLoader && <Loader />}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>

                            <div className="col-md-9">
                                <div className="billing-form-item mb-0">
                                    <div className="row mt-2">
                                        <div className="col-lg-12">
                                            <div
                                                className="billing-title-wrap"
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <div>
                                                    <h3 className="widget-title pb-0">Add New Candidate</h3>
                                                    <div className="title-shape margin-top-5px"></div>
                                                </div>
                                            </div>
                                            <div className="billing-content">
                                                <div className="postjob-form-action">
                                                    <form onSubmit={(e) => this.onSubmit(e)} >
                                                        <div className="row">
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        First Name{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                FIRST_NAME.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={FIRST_NAME.name}
                                                                            value={FIRST_NAME.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter First Name"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Last Name{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                LAST_NAME.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={LAST_NAME.name}
                                                                            value={LAST_NAME.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter Last Name"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Email{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                EMAIL.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={EMAIL.name}
                                                                            value={EMAIL.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter Email"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Mobile No{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                MOBILE_NUMBER.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={MOBILE_NUMBER.name}
                                                                            value={MOBILE_NUMBER.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type="text"
                                                                            placeholder="Enter Mobile No"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Current Location{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <div className="form-group">

                                                                            {/* <label className="label-text">
                                                                                    {LOCATION.value.map((item) => {
                                                                                        return (
                                                                                            <span className="locationbox">
                                                                                                {item.CITY}{" "}
                                                                                                <i
                                                                                                    onClick={() => {
                                                                                                        this.deleteLocation(item.CITY);
                                                                                                    }}
                                                                                                    className="fa fa-close"
                                                                                                ></i>
                                                                                            </span>
                                                                                        );
                                                                                    })}
                                                                                </label> */}
                                                                            <Typeahead
                                                                                id="ta-preferred-location-ids"
                                                                                allowNew={false}
                                                                                clearButton={false}
                                                                                labelKey={(option) => `${option.CITY}`}
                                                                                multiple={false}
                                                                                options={LOCATION.options}
                                                                                onInputChange={(e) => {
                                                                                    this.onKeywordPress(e, "LOCATION");
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    onChange(this, LOCATION.name, e)
                                                                                }}
                                                                                placeholder="Location"
                                                                                className={
                                                                                    LOCATION.error.length > 0
                                                                                        ? "errorMsg"
                                                                                        : ""
                                                                                }
                                                                                emptyLabel
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Preferred Location{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">

                                                                        <label className="label-text">
                                                                            {/* {PREFERRED_LOCATION.value.map((item) => {
                                                                                return (
                                                                                    <span className="locationbox">
                                                                                        {item.CITY}{" "}
                                                                                        <i
                                                                                            onClick={() => {
                                                                                                this.deletePrefferedLocation(item.CITY);
                                                                                            }}
                                                                                            className="fa fa-close"
                                                                                        ></i>
                                                                                    </span>
                                                                                );
                                                                            })} */}
                                                                        </label>
                                                                        <Typeahead
                                                                            id="ta-preferred-location-ids"
                                                                            allowNew={false}
                                                                            clearButton={false}
                                                                            labelKey={(option) => `${option.CITY}`}
                                                                            multiple={false}
                                                                            options={PREFERRED_LOCATION.options}
                                                                            onInputChange={(e) => {
                                                                                this.onKeywordPress(e, "PREFERRED_LOCATION");
                                                                            }}
                                                                            onChange={(e) => {
                                                                                this.locationOnChange(e);
                                                                            }}
                                                                            placeholder="Preferred Location"
                                                                            className={
                                                                                PREFERRED_LOCATION.error.length > 0
                                                                                    ? "errorMsg"
                                                                                    : ""
                                                                            }
                                                                            emptyLabel
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Gender{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={
                                                                                GENDER.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={GENDER.name}
                                                                            value={GENDER.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                        >
                                                                            <option value=''>Choose Gender</option>
                                                                            {GENDER_OPTIONS.map(item => {
                                                                                return (<option value={item.GENDER_ID}>{item.GENDER}</option>)
                                                                            })}

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Date Of Birth{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                DOB.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={DOB.name}
                                                                            value={DOB.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type='date'
                                                                        />

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Notice Period{" "}
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                NOTICE_PERIOD.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={NOTICE_PERIOD.name}
                                                                            value={NOTICE_PERIOD.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type="text"
                                                                            placeholder="Enter Notice Period"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Work Status{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group postjob-select-container">
                                                                        <select
                                                                            className={
                                                                                WORK_STATUS.error.length > 0
                                                                                    ? "postjob-select is-invalid"
                                                                                    : "postjob-select"
                                                                            }
                                                                            name={WORK_STATUS.name}
                                                                            value={WORK_STATUS.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option selected value=''>Choose Work Status</option>
                                                                            <option value='F'>Fresher</option>
                                                                            <option value='E'>Experienced</option>
                                                                        </select>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {WORK_STATUS.value === 'E' && <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Expereience{" "}

                                                                    </label>
                                                                    <div className="form-group d-flex" >
                                                                        <select
                                                                            className={
                                                                                TOTAL_EXPERIENCE_YEAR.error.length > 0 ? "form-control mr-2 is-invalid" : "form-control mr-2"
                                                                            }
                                                                            name={TOTAL_EXPERIENCE_YEAR.name}
                                                                            value={TOTAL_EXPERIENCE_YEAR.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Experience in Years --</option>
                                                                            {
                                                                                Array.from({ length: 50 }, (_, i) => <option value={i + 1}>{i + 1}  years </option>)
                                                                            }

                                                                        </select>

                                                                        <select
                                                                            className={
                                                                                TOTAL_EXPERIENCE_MONTH.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={TOTAL_EXPERIENCE_MONTH.name}
                                                                            value={TOTAL_EXPERIENCE_MONTH.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Experience in Month --</option>
                                                                            {
                                                                                Array.from({ length: 12 }, (_, i) => <option value={i}>{i}  months </option>)
                                                                            }

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>}<div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Salary{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group d-flex" >
                                                                        <select
                                                                            className={
                                                                                SALARY_IN_LAKH.error.length > 0 ? "form-control is-invalid" : "form-control mr-2"
                                                                            }
                                                                            name={SALARY_IN_LAKH.name}
                                                                            value={SALARY_IN_LAKH.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Salary In Lacs --</option>
                                                                            {
                                                                                Array.from({ length: 200 }, (_, i) => <option value={i + 0}>{i + 0} Lacs </option>)
                                                                            }
                                                                        </select>

                                                                        <select
                                                                            className={
                                                                                SALARY_IN_THOUSAND.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={SALARY_IN_THOUSAND.name}
                                                                            value={SALARY_IN_THOUSAND.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Salary In Thousands --</option>
                                                                            {
                                                                                Array.from({ length: 100 }, (_, i) => <option value={i + 0}>{i + 0} Thousands </option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Resume{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={RESUME.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            onChange={(e) => {
                                                                                this.onFileUpload(e)
                                                                            }}
                                                                            type="file"
                                                                            placeholder="Mention the Primary Email"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Education{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={EDUCATION.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={EDUCATION.name}
                                                                            value={EDUCATION.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value=''>Select Education</option>
                                                                            {EDUCATION_OPTIONS.map(item => {
                                                                                return (<option value={item.QUALIFICATION_ID}>{item.QUALIFICATION_NAME}</option>)
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Course{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={COURSE.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={COURSE.name}
                                                                            value={COURSE.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value=''>Select Course</option>
                                                                            {COURSE.options.map(item => {
                                                                                return (<option value={item.EDUCATION_QUALIFICATION_ID}>{item.COURSE_STREAM}</option>)
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Specialization
                                                                        {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={SPECIALIZATION.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={SPECIALIZATION.name}
                                                                            value={SPECIALIZATION.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value=''>Select Specialization</option>
                                                                            {SPECIALIZATION.options.map(item => {
                                                                                return (<option value={item.SPECIALIZATION_ID}>{item.SPECIALIZATION}</option>)
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        University/Institute {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={INSTITUTE.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={INSTITUTE.name}
                                                                            value={INSTITUTE.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                            type="text"
                                                                            placeholder="Your University/Institute"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Course Type
                                                                        {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={COURSE_TYPE.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={COURSE_TYPE.name}
                                                                            value={COURSE_TYPE.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value=''>Select Course Type</option>
                                                                            {COURSE_TYPE_OPTIONS && COURSE_TYPE_OPTIONS.map(item => {
                                                                                return (<option value={item.COURSE_TYPE_ID}>{item.COURSE_TYPE}</option>)
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Passing Out Year
                                                                        {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={PASSING_OUT_YEAR.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={PASSING_OUT_YEAR.name}
                                                                            value={PASSING_OUT_YEAR.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value="">Select Passing Out Year</option>
                                                                            {
                                                                                Array.from({ length: 50 }, (_, i) => <option value={(new Date().getFullYear()) - i}>{(new Date().getFullYear()) - i}</option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Grading System
                                                                        {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <select
                                                                            className={GRADING_SYSTEM.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={GRADING_SYSTEM.name}
                                                                            value={GRADING_SYSTEM.value}
                                                                            onChange={(e) => {
                                                                                this.onChange(e)
                                                                            }}
                                                                        >
                                                                            <option value=''>Choose a Grading System</option>
                                                                            {GRADING_SYSTEM_OPTIONS && GRADING_SYSTEM_OPTIONS.map(item => {
                                                                                return (<option value={item.GRADING_SYSTEM_ID}>{item.GRADING_SYSTEM_TYPE}</option>)
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {GRADING_SYSTEM.value !== '' && < div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Marks {" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <NumericFormat
                                                                            maxLength={5}
                                                                            className={MARKS.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            name={MARKS.name}
                                                                            value={MARKS.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            placeholder="Your Marks" />
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            <div className='col-lg-6 column-lg-full'>
                                                                <div className="form-group">
                                                                    <label className="label-text">
                                                                        Skills{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <Typeahead
                                                                        id="ta-skill-ids"
                                                                        allowNew={false}
                                                                        clearButton={false}
                                                                        labelKey={(option) => `${option.SKILL}`}
                                                                        multiple={true}
                                                                        options={KEYWORDS.options}
                                                                        onInputChange={(e) => {
                                                                            this.onKeywordPress(e, "SKILL");
                                                                        }}
                                                                        onChange={(e) => {
                                                                            this.skillsOnChange(e);
                                                                        }}
                                                                        placeholder="Add New Skill"
                                                                        className={
                                                                            KEYWORDS.error.length > 0
                                                                                ? "errorMsg"
                                                                                : ""
                                                                        }
                                                                        emptyLabel
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Selected Skills{" "}
                                                                        <span className="text-danger font-size-16">

                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <label className="label-text">
                                                                            {SELECTED_SKILLS.map((item) => {
                                                                                return (
                                                                                    <span className="locationbox">
                                                                                        {item.SKILL}{" "}
                                                                                        <i
                                                                                            onClick={() => {
                                                                                                this.deleteSKills(item.SKILL);
                                                                                            }}
                                                                                            className="fa fa-close"
                                                                                        ></i>
                                                                                    </span>
                                                                                );
                                                                            })}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row sq-db2">
                                                                <div className="col-lg-12 pl-4 sq-db2">
                                                                    <div className="btn-box mt-4 pl-1 sq-db2">
                                                                        <button type="submit" disabled={showLoader} style={showLoader ? { backgroundColor: '#4c4c4c' } : {}} className="theme-btn border-0">
                                                                            <i className="la la-plus sq-db2"></i> Submit
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section >
            </React.Fragment >
        )
    }
}
export default withRouter(Onboard)